import './style.css';
import CircleStepper from '../CircleStepper';

const Stepper = ({ steps, step = 0 }: { steps?: number; withDivisor?: boolean; step?: number }) => {
  return <CircleStepper stepsCount={steps || 0} current={step} />;
};

export default Stepper;
